module.exports = __webpack_public_path__ + "static/media/camera-icon-white.413d9ece.svg";